export default __webpack_public_path__ + "static/media/prenatalLandingPageTestimonial1.55e744b7.png";